(function($) {
  $(document).ready(function() {

    /* Isotope.JS initialisieren */
    let grid = $('.stories-grid').isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer',
        gutter: 22
      }
    });

    /* Kategorie Filter starten */
    $('#category-filter').on('change', function() {
      let filterValue = $(this).val();
      grid.isotope({
        filter: filterValue
      });
    });

    /* Tags Filter starten */
    $('#tags-filter').on('change', function() {
      let filterValue = $(this).val();
      grid.isotope({
        filter: filterValue
      });
    });

    // use value of search field to filter
    let $quicksearch = $('#searchFilter').keyup( debounce( function() {
      qsRegex = new RegExp( $quicksearch.val(), 'gi' );
      grid.isotope({
        filter: function() {
          return qsRegex ? $(this).text().match( qsRegex ) : true;
        }
      });
    }, 200 ) );

    // debounce so filtering doesn't happen every millisecond
    function debounce( fn, threshold ) {
      var timeout;
      threshold = threshold || 100;
      return function debounced() {
        clearTimeout( timeout );
        var args = arguments;
        var _this = this;
        function delayed() {
          fn.apply( _this, args );
        }
        timeout = setTimeout( delayed, threshold );
      };
    }
  });
})(jQuery);